// extracted by mini-css-extract-plugin
module.exports = {"contactBlockWrapper":"ContactBlock_contactBlockWrapper__Z2H73","horizontal":"ContactBlock_horizontal__GAk3g","vertical":"ContactBlock_vertical___2Ggm"};